export enum TestimonialVariants {
  Base = 'Base',
  V2 = 'V2',
}
